<template>
  <div class="information-student summary-learnning">
    <h4 class="title-section">{{ title }}</h4>
    <div class="box p-grid">
        <div class="left p-col-12 p-sm-5 p-md-5 p-lg-5 p-xl-5">
            <div class="item">
                <label for="">Điểm TB học tập:</label>
                <h3>{{ summaryLearning.averageMark }}</h3>
            </div>
            <div class="item">
                <label for="">Điểm chuyên cần:</label>
                <h3>{{ summaryLearning.diligentMark }}</h3>
            </div>
        </div>
        <div class="right p-col-12 p-sm-5 p-md-5 p-lg-5 p-xl-5">
            <div class="item">
                <label for="">Điểm tổng kết:</label>
                <h3>{{ summaryLearning.totalMark }}</h3>
            </div>
            <div class="item">
                <label for="">Xếp hạng:</label>
                <h3>{{ summaryLearning.rank }}</h3>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SummaryLearning',
  props: ['summaryLearning', 'title'],
  components: {},
  data() {
    return {
    }
  },
  watch: {
  },
  mounted () {
  },
  created() {
  },
  methods: {
    
  }
}
</script>

<style>
</style>